import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Plus, ClockCountdown, NavigationArrow, Truck, CheckCircle, XCircle,
} from '@phosphor-icons/react';

// Phase 78z — Booking Home tiles. The 5 status tabs + "New Booking"
// stopped fitting in one line on mobile after Phase 78y, causing the
// "+ New Booking" button to collide with the tab strip. This landing
// screen presents 6 large, touch-friendly tiles. Each tile navigates
// to either the New Booking form or to My Trips with a pre-selected tab.
const TILES = [
  {
    label: 'Pending',
    sub: 'Waiting for allocation',
    icon: ClockCountdown,
    target: '/booking/trips?tab=pending',
    color: '#808080',
    bg: '#808080',
    testid: 'tile-pending',
  },
  {
    label: 'Allocated',
    sub: 'Pilot assigned',
    icon: Truck,
    target: '/booking/trips?tab=allocated',
    color: '#002FA7',
    bg: '#002FA7',
    testid: 'tile-allocated',
  },
  {
    label: 'In Progress',
    sub: 'On the road',
    icon: NavigationArrow,
    target: '/booking/trips?tab=in_progress',
    color: '#FF8C00',
    bg: '#FF8C00',
    testid: 'tile-in-progress',
  },
  {
    label: 'Completed',
    sub: 'Finished today',
    icon: CheckCircle,
    target: '/booking/trips?tab=completed',
    color: '#00C853',
    bg: '#00C853',
    testid: 'tile-completed',
  },
  {
    label: 'Cancelled',
    sub: 'Trips called off',
    icon: XCircle,
    target: '/booking/trips?tab=cancelled',
    color: '#FF3333',
    bg: '#FF3333',
    testid: 'tile-cancelled',
  },
  {
    label: 'New Booking',
    sub: 'Book a fresh trip',
    icon: Plus,
    target: '/booking/new',
    color: '#0A0A0A',
    bg: '#0A0A0A',
    testid: 'tile-new-booking',
    emphasis: true,
  },
];

export default function BookingHome() {
  const navigate = useNavigate();
  return (
    <div data-testid="booking-home" className="space-y-6">
      <div>
        <h1 className="text-4xl font-black tracking-tighter text-[#0A0A0A]">Booking</h1>
        <p className="text-sm text-[#666] mt-1">Pick a list — or start a new booking.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        {TILES.map(t => (
          <button
            key={t.target}
            onClick={() => navigate(t.target)}
            data-testid={t.testid}
            className={`relative group rounded-2xl border bg-white px-4 py-6 text-left shadow-sm hover:shadow-md transition-all flex flex-col gap-3 min-h-[140px] ${
              t.emphasis ? 'border-[#002FA7] ring-1 ring-[#002FA7]/20' : 'border-[#E5E5E5]'
            }`}
            style={{ borderLeft: `4px solid ${t.bg}` }}
          >
            <div
              className="w-10 h-10 rounded-full flex items-center justify-center"
              style={{ backgroundColor: `${t.bg}15`, color: t.color }}
            >
              <t.icon size={22} weight="bold" />
            </div>
            <div>
              <p className="text-lg font-bold text-[#0A0A0A] uppercase tracking-tight">{t.label}</p>
              <p className="text-xs text-[#666] mt-0.5">{t.sub}</p>
            </div>
            {t.emphasis && (
              <span
                className="absolute top-3 right-3 text-[9px] uppercase tracking-widest text-white px-2 py-0.5 rounded-full"
                style={{ background: t.bg }}
              >
                New
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
